import { styled } from '@mui/material'

export const DashboardBackground = styled('div')`
    position: fixed;
    z-index: -1;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: #f7f7f7;
`
